import React, { useContext } from 'react';
import { TiDelete } from 'react-icons/ti';
import { AppContext } from '../context/AppContext';

const ExpenseItem = (props) => {
	const { dispatch } = useContext(AppContext);

	const handleDeleteExpense = () => {
		dispatch({
			type: 'DELETE_EXPENSE',
			payload: props.id,
		});
	};

	return (
		<li class='list-group-item d-flex justify-content-between align-items-center' style={{display: 'flex', justifyContent: 'space-between'}}>
		  <div style={{flex: '1', marginRight: '1rem'}}>
			{props.name}
		  </div>
		  <div style={{flex: '1', marginRight: '1rem', textAlign: 'center'}}>
			₹{props.cost}
		  </div>
		  <div style={{flex: '1', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
			<span class='badge badge-primary badge-pill mr-3'>₹{props.cost}</span>
			<TiDelete size='1.5em' onClick={handleDeleteExpense} />
		  </div>
		</li>
	  );
	  
};

export default ExpenseItem;